import z from "zod";

import { LadyCommonDto } from "@/models/lady-dtos";
import { FormsWrapper } from "@/models/utils.models";

export const LadySearchListResponseDto = FormsWrapper(LadyCommonDto);

export type LadySearchListResponseDto = z.infer<
  typeof LadySearchListResponseDto
>;

export * from "./searchInputs.schema";
export * from "./searchSelectsValues.dto";
export * from "./inputValuesRes.dto";
export * from "./searchPageLadies.response";
export * from "./searchPage.query";
